export default "__VITE_ASSET__D9ECN7DD__"